import styled from '@emotion/styled';

export const DataGridComponentDiv = styled('div')`
  .data-grid-wrapper{
    margin: 0.5 !important;
  }
`;
export const NoDataGridComponentDiv = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5rem;
`;
